<template>
  <div v-if="show_historical_usage">
    total cost of this plan based on your {{ historical_usage_count }} months of usage history
  </div>
  <div v-else>
    monthly bill estimate for {{ usage_selected }} kWh usage
  </div>
</template>

<script>
import UsageFilters from "src/composables/UsageFilters";
import Utilities from "src/composables/Utilities";

export default {
  name: "PlanTotalDescription",
  props: {
    plan: {
      type: Object
    }
  },
  setup() {
    const { usage_selected, show_historical_usage, historical_usage_count } = UsageFilters();
    return {
      show_historical_usage,
      historical_usage_count,
      usage_selected
    }
  }
}
</script>

<style scoped>

</style>